import { Component, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { FaqStructuredData } from '@core/structured-data';
import { StructuredDataModule } from '@core/structured-data';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
} from '@ng-bootstrap/ng-bootstrap';
import { TrackInteractionDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { PartialAccordionTitleComponent } from '@legacy/common-ui-partials';
import {
  ImageComponent,
  RichTextWrapperComponent,
} from '@legacy/common-ui-utility-components';

import { QuickFeedbackComponent } from './quick-feedback/quick-feedback.component';
import type { FaqAccordionItem } from './faq.model';
import { FaqAccordionViewModel } from './faq.model';

@Component({
  selector: 'wl-faq[faqAccordionViewModel]',
  templateUrl: './faq.component.html',
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    TrackInteractionDirective,
    AutomationIdDirective,
    PartialAccordionTitleComponent,
    NgbAccordionCollapse,
    NgbAccordionBody,
    RichTextWrapperComponent,
    ImageComponent,
    QuickFeedbackComponent,
    StructuredDataModule,
  ],
})
export class FaqComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() faqAccordionViewModel!: FaqAccordionViewModel;

  trackByItem(_index: number, item: FaqAccordionItem): string {
    return item.id;
  }

  get items(): FaqAccordionItem[] {
    return this.faqAccordionViewModel.items;
  }

  get isVertical(): boolean {
    return this.faqAccordionViewModel.isVertical;
  }

  get feedbackSettings(): InnogyComponentRendering | undefined {
    return this.faqAccordionViewModel.feedbackSettings;
  }

  get structuredData(): FaqStructuredData {
    return this.faqAccordionViewModel.structuredData;
  }
}
